export const S3_BUCKET_MCON = {
  production: 'prod-mp-mps-mcon',
  staging: 'stg-mp-mps-mcon',
  development: 'stg-mp-mps-mcon',
};

export const MCON_LISENCE_TYPE = {
  NON_COMMERCIAL: 'NON_COMMERCIAL',
  COMMERCIAL: 'COMMERCIAL',
};
